import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminComponent {
  constructor ($state, $session, $scope, Permisos, $rootScope, AppHttpInterceptor) {
    this.$state = $state
    this.$session = $session
    this.Permisos = Permisos
    this.$rootScope = $rootScope
    this.user = null
    this.search = null
    this.token = null
    this.fanconsultoresAdminAuth = null
    AppHttpInterceptor.auth = () => this.auth()
    $scope.$on('$app:notSupported', (event, params) => (this.appNotSupported(event, params)))
    $scope.$on('$app:unauthorized', (event, params) => (this.appUnauthorized(event, params)))
    $scope.$on('$sessionAuth', (event, params) => (this.sessionAuth(event, params)))
    $scope.$on('$sessionUnauth', (event, params) => (this.sessionUnauth(event, params)))
  }

  $onInit () {
    if (this.$session.isAuth()) this.sessionAuth()
  }

  auth () {
    return this.fanconsultoresAdminAuth.open().then(() => (this.$state.reload()))
  }

  logout () {
    this.$session.unauth()
  }

  login () {
    this.$state.go('dashboard')
  }

  appNotSupported () {
    this.$state.go('app.notSuported', {}, {location: false})
      .then(() => {
        this.$rootScope.$on('$stateChangeStart', (event) => (event.preventDefault()))
      })
  }

  appUnauthorized (event, params) {
    this.$state.go('app.login', params, {location: false})
  }

  sessionAuth (event, token) {
    this.token = token
    this.user = undefined
    this.search = undefined

    if (this.$session.isAuth()) {
      this.$session.data()
        .then((user) => (this.user = user))

      this.Permisos.modulos({search: 'kendu.empleados'})
        .then((permisos) => (this.search = permisos.search))
    }
  }

  sessionUnauth () {
    this.token = null
    this.user = undefined
    this.search = undefined
    this.$state.go('app.logout', {}, {location: false})
  }
}

module.component('fanconsultoresAdmin', {
  controller: FanconsultoresAdminComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/component.js